const POS_META = {
  A: { label: 'FWD', tone: 'fwd' },
  F: { label: 'FWD', tone: 'fwd' },
  FW: { label: 'FWD', tone: 'fwd' },
  D: { label: 'DEF', tone: 'def' },
  DEF: { label: 'DEF', tone: 'def' },
  M: { label: 'MID', tone: 'mid' },
  MID: { label: 'MID', tone: 'mid' },
  MF: { label: 'MID', tone: 'mid' },
  G: { label: 'GK', tone: 'gk' },
  GK: { label: 'GK', tone: 'gk' },
};

export function positionMeta(position) {
  const key = String(position || '')
    .trim()
    .toUpperCase();
  return POS_META[key] || { label: key || '—', tone: 'other' };
}

export function playerInitials(name) {
  const parts = String(name || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (!parts.length) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
}
